module.exports = __webpack_public_path__ + "static/media/55_000052.e0a00827.jpg";